var _desc, _defs, _rect, _rect2, _rect3, _line, _g, _circle, _circle2, _path, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _g2, _rect1, _path2, _rect10, _rect11, _rect12, _rect13, _g3, _circle3, _circle4, _circle5, _circle6, _text, _text2, _g4, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkillmatch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 450",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "smTitle"
  }, "SkillMatch AI") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "smTitle"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "smDesc"
  }, "A resume card and a role card connected through a match-score ring on a light dashboard background.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "smRing",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7c3aed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2563eb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "smLink",
    x1: 180,
    y1: 205,
    x2: 620,
    y2: 205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7c3aed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2563eb"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "smShadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 5,
    stdDeviation: 9,
    floodColor: "#3b3f8a",
    floodOpacity: 0.16
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "smTint1",
    cx: 0.15,
    cy: 0.1,
    r: 0.7
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7c3aed",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c3aed",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "smTint2",
    cx: 0.9,
    cy: 0.9,
    r: 0.7
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2563eb",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2563eb",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 450,
    fill: "#f5f6fb"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 450,
    fill: "url(#smTint1)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 450,
    fill: "url(#smTint2)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 205,
    x2: 620,
    y2: 205,
    stroke: "url(#smLink)",
    strokeWidth: 3,
    strokeDasharray: "2 9",
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#smShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 120,
    width: 200,
    height: 170,
    rx: 14,
    fill: "#ffffff"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 160,
    r: 20,
    fill: "#ede7fd"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 153,
    r: 7.5,
    fill: "#7c3aed"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98 174 C98 164 126 164 126 174",
    fill: "#7c3aed"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 146,
    width: 100,
    height: 9,
    rx: 4.5,
    fill: "#2a2f4a"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 163,
    width: 68,
    height: 7,
    rx: 3.5,
    fill: "#b9bed6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 202,
    width: 160,
    height: 7,
    rx: 3.5,
    fill: "#d9dcec"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 220,
    width: 132,
    height: 7,
    rx: 3.5,
    fill: "#d9dcec"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 238,
    width: 148,
    height: 7,
    rx: 3.5,
    fill: "#d9dcec"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 260,
    width: 56,
    height: 16,
    rx: 8,
    fill: "#ede7fd"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 260,
    width: 56,
    height: 16,
    rx: 8,
    fill: "#e3ecfd"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#smShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 528,
    y: 120,
    width: 200,
    height: 170,
    rx: 14,
    fill: "#ffffff"
  }))), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 548,
    y: 142,
    width: 34,
    height: 26,
    rx: 5,
    fill: "none",
    stroke: "#2563eb",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M558 142 L558 137 A4 4 0 0 1 562 133 L568 133 A4 4 0 0 1 572 137 L572 142",
    fill: "none",
    stroke: "#2563eb",
    strokeWidth: 3
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 548,
    y: 152,
    width: 14,
    height: 3,
    fill: "#2563eb"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 568,
    y: 152,
    width: 14,
    height: 3,
    fill: "#2563eb"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 594,
    y: 146,
    width: 110,
    height: 9,
    rx: 4.5,
    fill: "#2a2f4a"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 594,
    y: 163,
    width: 72,
    height: 7,
    rx: 3.5,
    fill: "#b9bed6"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 556,
    cy: 208,
    r: 8,
    fill: "#34a56f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 208 L555 211 L560 204",
    stroke: "#ffffff",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 572,
    y: 204,
    width: 130,
    height: 7,
    rx: 3.5,
    fill: "#d9dcec"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 556,
    cy: 232,
    r: 8,
    fill: "#34a56f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552 232 L555 235 L560 228",
    stroke: "#ffffff",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 572,
    y: 228,
    width: 108,
    height: 7,
    rx: 3.5,
    fill: "#d9dcec"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 556,
    cy: 256,
    r: 8,
    fill: "none",
    stroke: "#e8933c",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 572,
    y: 252,
    width: 120,
    height: 7,
    rx: 3.5,
    fill: "#f3ddc3"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 205,
    r: 70,
    fill: "#f5f6fb"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 205,
    r: 62,
    fill: "#ffffff",
    filter: "url(#smShadow)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 205,
    r: 62,
    fill: "none",
    stroke: "#e6e8f4",
    strokeWidth: 10
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 205,
    r: 62,
    fill: "none",
    stroke: "url(#smRing)",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeDasharray: "358.3 389.6",
    transform: "rotate(-90 400 205)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 205,
    textAnchor: "middle",
    fontFamily: "'Segoe UI', system-ui, sans-serif",
    fontSize: 36,
    fontWeight: 700,
    fill: "#2a2f4a"
  }, "92%")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 230,
    textAnchor: "middle",
    fontFamily: "Consolas, ui-monospace, monospace",
    fontSize: 13,
    fill: "#8b90ad"
  }, "match")), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Consolas, ui-monospace, monospace",
    fontSize: 14,
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 78,
    width: 82,
    height: 28,
    rx: 14,
    fill: "#ffffff",
    stroke: "#c9b8f5",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 347,
    y: 97,
    fill: "#6d3fd2"
  }, "python"), /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 78,
    width: 60,
    height: 28,
    rx: 14,
    fill: "#ffffff",
    stroke: "#aec4f2",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 446,
    y: 97,
    fill: "#2563eb"
  }, "sql"), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 318,
    width: 72,
    height: 28,
    rx: 14,
    fill: "#ffffff",
    stroke: "#aec4f2",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 342,
    y: 337,
    fill: "#2563eb"
  }, "react"), /*#__PURE__*/React.createElement("rect", {
    x: 404,
    y: 318,
    width: 96,
    height: 28,
    rx: 14,
    fill: "#ffffff",
    stroke: "#eec79a",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 452,
    y: 337,
    fill: "#d97a1f"
  }, "aws \xB7 gap"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 410,
    textAnchor: "middle",
    fontFamily: "'Segoe UI', system-ui, sans-serif",
    fontSize: 30,
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#2a2f4a"
  }, "SkillMatch "), /*#__PURE__*/React.createElement("tspan", {
    fill: "#7c3aed"
  }, "AI"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillmatch);
export default __webpack_public_path__ + "static/media/skillmatch.cb2bde6d4cca1003a13835ec6d665f24.svg";
export { ForwardRef as ReactComponent };